import React, { useState } from "react";
import { FaCompass, FaBookOpen, FaHandshake } from "react-icons/fa";

const nowItems = [
  {
    id: 1,
    title: "Current Focus",
    details:
      "Scaling mobile banking features, upgrading React Native architecture, and tightening CI pipelines.",
    icon: <FaCompass />,
  },
  {
    id: 2,
    title: "Learning",
    details:
      "Advanced performance profiling, micro-frontend strategies, and design system governance.",
    icon: <FaBookOpen />,
  },
  {
    id: 3,
    title: "Open to",
    details:
      "Strategic advisory, front-end architecture reviews, and product discovery workshops.",
    icon: <FaHandshake />,
  },
];

const Now = () => {
  const [gitView, setGitView] = useState("heatmap");
  const [heatmapError, setHeatmapError] = useState(false);

  return (
    <section className="section now-section" id="now">
      <div className="section-title" data-aos="fade-up">
        <h2>Now</h2>
        <div className="underline"></div>
        <p className="projects-description">
          A snapshot of what I am focused on right now.
        </p>
      </div>

      <div className="now-grid">
        {nowItems.map((item, index) => (
          <div
            key={item.id}
            className="now-card"
            data-aos="fade-up"
            data-aos-delay={index * 90}
          >
            <div className="now-card-header">
              <span className="now-icon">{item.icon}</span>
              <h3>{item.title}</h3>
            </div>
            <p>{item.details}</p>
          </div>
        ))}
      </div>

      <div className="hero-git-panel now-git-panel" data-aos="fade-up">
        <div className="hero-git-header">
          <span className="hero-git-title">Git Activity</span>
          <div className="hero-git-tabs">
            {[
              { key: "heatmap", label: "Heatmap" },
              { key: "activity", label: "Activity" },
            ].map((tab) => (
              <button
                key={tab.key}
                type="button"
                className={`hero-git-tab ${
                  gitView === tab.key ? "active" : ""
                }`}
                onClick={() => setGitView(tab.key)}
              >
                {tab.label}
              </button>
            ))}
          </div>
        </div>
        <div className="hero-git-visual">
          {gitView === "heatmap" && (
            <div className="git-heatmap">
              <div className="git-heatmap-header">
                <span className="git-heatmap-title">
                  Contributions in the last year
                </span>
                <span className="git-heatmap-settings">
                  Contribution settings
                </span>
              </div>

              <div className="git-heatmap-body">
                <div className="git-heatmap-grid">
                  {!heatmapError ? (
                    <img
                      src="https://ghchart.rshah.org/56d364/juac08"
                      alt="GitHub contributions heatmap"
                      loading="lazy"
                      onError={() => setHeatmapError(true)}
                    />
                  ) : (
                    <svg
                      viewBox="0 0 640 180"
                      role="img"
                      aria-label="GitHub contributions heatmap fallback"
                    >
                      {Array.from({ length: 14 }).map((_, row) =>
                        Array.from({ length: 24 }).map((_, col) => {
                          const x = 24 + col * 24;
                          const y = 24 + row * 10;
                          const intensity =
                            (row * 24 + col) % 7 < 2
                              ? 0.15
                              : (row * 24 + col) % 7 < 4
                                ? 0.35
                                : (row * 24 + col) % 7 < 6
                                  ? 0.6
                                  : 0.85;
                          return (
                            <rect
                              key={`${row}-${col}`}
                              x={x}
                              y={y}
                              width="14"
                              height="8"
                              rx="2"
                              fill={`rgba(86, 211, 100, ${intensity})`}
                            />
                          );
                        }),
                      )}
                    </svg>
                  )}
                </div>
                <div className="git-heatmap-legend">
                  <span>Less</span>
                  <div className="legend-dots">
                    {[1, 2, 3, 4].map((lvl) => (
                      <span key={lvl} className={`dot level-${lvl}`}></span>
                    ))}
                  </div>
                  <span>More</span>
                </div>
              </div>
            </div>
          )}

          {gitView === "activity" && (
            <img
              src="https://github-readme-activity-graph.vercel.app/graph?username=juac08&bg_color=ffffff&color=0e7490&line=22c55e&point=0ea5e9&area=true&hide_border=true"
              alt="GitHub activity graph"
              loading="lazy"
            />
          )}
        </div>
      </div>
    </section>
  );
};

export default Now;
